export class trendingTopicsList{
    value: number;
    topics: string;
    rowNo:number;
    constructor () {
        this.value = 0;
        this.topics = '';
        this.rowNo=0;
    }
}
export class topFiveTrendingTopic{
    name: string;
    data: number[];
    constructor () {
        this.name = '';
        this.data = [];
    }
}
export class TopFiveDatelist{
    date: string[];
    constructor () {
        this.date = [];
    }
}
export class trendingTopicOutput{
    trendingTopic!: trendingTopicsList[];
    topFiveTrendingTopic!: topFiveTrendingTopic[];
    topFiveDatelist!: string[];
}
export class trendingTopicInput{
    fromDate!: string;
    toDate!: string;
    totalTopic!: number;
    regulator!: string[] | null;
    country!: string[];
    trendingTopics!: string[] | null;
    isTopTypeChange:boolean=false;
}
